/**
 * DescriptionTerm
 */
import React from 'react';
import clsx from 'clsx';
/** Main description for this component. */
var DescriptionTerm = function (_a) {
    var text = _a.text, _b = _a.fontWeight, fontWeight = _b === void 0 ? 'bold' : _b;
    return (React.createElement("dt", { className: clsx('w-64 flex-none text-p', fontWeight === 'bold' && 'font-bold') }, text));
};
export default DescriptionTerm;
